import { formatPeriodo } from '@ops/contracts'

import { useOverview } from '../../lib/queries'
import { usePeriodo } from '../../shell'
import { Section } from '../../ui'
import { AdminOverviewVista } from './AdminOverview'
import { ComercialOverviewVista } from './ComercialOverview'
import { OpsOverviewVista } from './OpsOverview'
import { Cargando, ErrorDeCarga } from '../comunes'
import { TableroDialogos, useTablero } from './tablero'

/**
 * Overview: la primera pantalla de los tres roles.
 *
 * Esta página solo orquesta — pide el payload, resuelve carga y error, y elige la
 * variante. El rol **no** es un parámetro ni una decisión del front: viene
 * discriminado en el payload (`rol`), que el servidor arma según el usuario
 * autenticado. Por eso el `switch` es exhaustivo y TypeScript garantiza que cada
 * rama recibe solo las secciones que existen para su rol: si mañana ops recibiera
 * `mrrTrend`, no compilaría.
 *
 * El período sale del shell (`usePeriodo`) y nunca de estado local: si cada
 * pantalla tuviera el suyo, una tabla podría mostrar junio al lado de un KPI de
 * julio.
 */
export default function OverviewPage() {
  const { periodo } = usePeriodo()
  const consulta = useOverview(periodo)
  const tablero = useTablero(periodo)

  if (consulta.isPending) {
    return (
      <Section
        titulo="Cómo viene el período"
        bajada={`Trayendo el tablero de ${formatPeriodo(periodo)}.`}
        regla={false}
      >
        <Cargando
          que={`el tablero de ${formatPeriodo(periodo)}`}
          alto="lg"
          testId="overview-cargando"
        />
      </Section>
    )
  }

  if (consulta.isError) {
    return (
      <Section
        titulo="No pudimos abrir el tablero"
        bajada="El panel no muestra nada hasta saber qué pasó: un tablero a medias se lee como un tablero vacío."
        regla={false}
      >
        <ErrorDeCarga
          que={`el tablero de ${formatPeriodo(periodo)}`}
          error={consulta.error}
          onRetry={() => void consulta.refetch()}
          reintentando={consulta.isFetching}
          testId="overview-error-mensaje"
        />
      </Section>
    )
  }

  const payload = consulta.data

  return (
    <>
      {payload.rol === 'admin' ? (
        <AdminOverviewVista payload={payload} tablero={tablero} />
      ) : payload.rol === 'ops' ? (
        <OpsOverviewVista payload={payload} tablero={tablero} />
      ) : (
        <ComercialOverviewVista payload={payload} tablero={tablero} />
      )}

      <TableroDialogos tablero={tablero} periodo={periodo} />
    </>
  )
}
